import { createTheme, type Theme } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { valutMuiComponents } from "./valutMuiComponents";

type CreateValutMuiThemeOptions = {
  primaryColor: string;
  mode: "light" | "dark";
};

const darkPalette = {
  background: {
    default: "#0a0a0a",
    paper: "#141414",
  },
  text: {
    primary: "#f3f4f6",
    secondary: "#9ca3af",
  },
  divider: "#262626",
};

const lightPalette = {
  background: {
    default: "#F8F8F8",
    paper: "#ffffff",
  },
};

export const createValutMuiTheme = ({
  primaryColor,
  mode,
}: CreateValutMuiThemeOptions): Theme =>
  createTheme(
    {
      palette: {
        mode,
        primary: {
          main: primaryColor,
        },
        ...(mode === "dark" ? darkPalette : lightPalette),
      },
      typography: {
        fontFamily: '"Instrument Sans", sans-serif',
      },
      shape: {
        borderRadius: 8,
      },
      components: {
        ...valutMuiComponents,
        MuiDialog: {
          styleOverrides: {
            paper: {
              ...(mode === "dark"
                ? {
                    backgroundColor: "#141414",
                    color: "#f3f4f6",
                    border: "1px solid #262626",
                  }
                : {}),
            },
          },
        },
        MuiDrawer: {
          styleOverrides: {
            paper: {
              ...(mode === "dark"
                ? {
                    backgroundColor: "#141414",
                    borderRight: "1px solid #262626",
                  }
                : {}),
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              ...(mode === "dark"
                ? {
                    backgroundColor: "#1a1a1a",
                    "&.Mui-disabled": {
                      backgroundColor: "#141414",
                    },
                  }
                : {}),
            },
            input: {
              ...(mode === "dark" ? { color: "#f3f4f6" } : {}),
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              ...(mode === "dark" ? { color: "#9ca3af" } : {}),
            },
          },
        },
        MuiFilledInput: {
          styleOverrides: {
            root: {
              ...(mode === "dark"
                ? {
                    backgroundColor: "#1a1a1a",
                    "&:hover": { backgroundColor: "#1a1a1a" },
                    "&.Mui-focused": { backgroundColor: "#1a1a1a" },
                  }
                : {}),
            },
          },
        },
        MuiAutocomplete: {
          styleOverrides: {
            inputRoot: {
              ...(mode === "dark" ? { backgroundColor: "#1a1a1a" } : {}),
            },
          },
        },
      },
    },
    ptBR
  );
